import { Typography, Button, makeStyles, Card, CardContent } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProfile } from '../../data';
import { CircularProgress, Divider } from '@material-ui/core';

export default function HomepageUser(props) {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            minHeight: 400,
        },
        grid: {
            maxWidth: 400,
            alignSelf: 'center',
            flex: 'auto',
        },
        robot: {
            width: 200,
            marginBottom: theme.spacing(2),
        },
        textField: {
            width: 200,
            margin: theme.spacing(2),
        },
        menuButton: {
            width: 200,
            margin: theme.spacing(1),
            display: 'inline-block',
        }
    }));
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [activeLeagues, setActiveLeagues] = useState([]);
    const [archivedLeagues, setArchivedLeagues] = useState([]);
    useEffect(() => {
        (async () => {
            const profile = await getProfile();
            setActiveLeagues(profile['leagues'].filter(league => league.isActive));
            setArchivedLeagues(profile['leagues'].filter(league => !league.isActive));
            setLoading(false);
        })();
    }, []);
    return (
        <div style={{ minHeight: '500px', position: 'relative' }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="h5">
                        Active Leagues
                    </Typography>
                    {loading && <CircularProgress />}
                    {!loading && activeLeagues.map(l => {
                        return (
                            <Link key={l.leagueID} to={`/leagues/${l.leagueID}`} className={classes.menuButton}>
                                <Button variant='contained'>{l.name}</Button>
                            </Link>
                        )
                    })}
                    {!loading && activeLeagues.length === 0 &&
                        <Typography>
                        No active leagues
                        </Typography>
                    }
                    <Divider style={{margin: 10}} />
                    <Typography variant="h5" component="h5">
                        Create League
                    </Typography>
                    <Link to={'/leagues/create'} className={classes.menuButton}>
                        <Button variant='contained' color='primary'>Create League</Button>
                    </Link>
                    <Divider style={{margin: 10}} />
                    <Typography variant="h5" component="h5">
                        Archived Leagues
                    </Typography>
                    {!loading && archivedLeagues.map(l => {
                        return (
                            <Link key={l.leagueID} to={`/leagues/${l.leagueID}`} className={classes.menuButton}>
                                <Button variant='contained'>{l.name}</Button>
                            </Link>
                        )
                    })}
                </CardContent>
            </Card>
        </div>
    );
};